import React from "react";
import ReactDOM from 'react-dom/client';

// antd v5's static APIs — message, notification, Modal — are built on
// ReactDOM.render, which React 19 removed. Without this patch they fail
// silently: no toast, no exception, no console warning. Must be imported
// before anything that touches antd.
import '@ant-design/v5-patch-for-react-19';

// import { BrowserRouter } from "react-router-dom";
import AppRouter from "./AppRouter";

// import { App } from "./app";
import 'bootstrap/dist/css/bootstrap.min.css';
//CSS & Bootstrap
import "./assets/css/style.css";
import "./assets/css/eclinic-design-system.css";
//  import "./assets/js/bootstrap.bundle.min.js";
import "./assets/css/select2.min.css";
//Font Awesome
// import "./assets/plugins/fontawesome/css/fontawesome.min.css";
// import "./assets/plugins/fontawesome/css/all.min.css";
import '../node_modules/@fortawesome/fontawesome-free/css/all.min.css';
import '../node_modules/@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.js';



const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <AppRouter />
);